import { apiService, SupportedOS } from "@blacknut/javascript-sdk/dist";
import React from "react";
import { isAISBuild, isDreiBuild, isM1Build, isTelecallBuild } from "src/utils/Utils";

import "react-simple-keyboard/build/css/index.css";
import { StorageKey } from "core/services";

export const PreviewPage = React.lazy(() => import(`src/pages/Preview`));

export const AccountPage = React.lazy(() => import(`src/pages/Account`));

export const SearchPage = React.lazy(() => import(`src/pages/Search`));

export const SearchResultsPage = React.lazy(() => import(`src/pages/SearchResults`));

export const LeMagPage = React.lazy(() => import(`src/pages/LeMag`));

export const LeMagArticlePage = React.lazy(() => import(`src/pages/LeMagArticle`));

export const MyListPage = React.lazy(() => import(`src/pages/MyList`));

export const BrowsePage = React.lazy(() => import(`src/pages/Browse`));

export const CategoryPage = React.lazy(() => import(`src/pages/Category`));

export const LinkPage = React.lazy(() => import(`src/pages/Link`));

export const PassPage = React.lazy(() => import(`src/pages/Pass`));

export const GameGenrePage = React.lazy(() => import(`src/pages/Game/PageGameGenre`));

export const GamePage = React.lazy(() => import(`src/pages/Game`));

export const GamePlayPage = React.lazy(() => import(`src/pages/GamePlayPage`));

export const ActivateGamePage = React.lazy(() => import(`src/pages/GameActivate`));

export const BonusPage = React.lazy(() => import(`src/pages/Bonus`));

export const PYGPage = React.lazy(() => import(`src/pages/PYG`));

export const AllBonusPage = React.lazy(() => import(`src/pages/BonusGames`));

export const ProfilesPage = React.lazy(() => import(`src/pages/Profiles`));

export const ProfilePinPage = React.lazy(() => import(`src/pages/ProfilesPin`));

export const OfflinePage = React.lazy(() => import(`src/pages/Offline`));

export const GamesByCategoryPage = React.lazy(
  () => import(`src/pages/Game/PageGameGenre/PageGamesByCategory`),
);

export const GamepadPage = React.lazy(() => import(`src/pages/Gamepad`));

export const OauthPage = React.lazy(() => import(`src/pages/Oauth`));

export const LoginPage = React.lazy(() => {
  if (isM1Build()) return import("src/pages/Onboarding/m1/Signin/Signin");
  throw new Error("unsupported");
});

export const OnboardingPage = React.lazy(() => {
  if (isM1Build()) return import("src/pages/Onboarding/m1/Welcome");
  if (isDreiBuild()) return import("src/pages/Onboarding/drei");
  if (isAISBuild()) return import("src/pages/Onboarding/ais");
  if (isTelecallBuild()) return import("src/pages/Onboarding/telecall");
  if (
    apiService.userAgent.os === SupportedOS.Webos &&
    localStorage.getItem(StorageKey.FEAT_WEBOS10YRS)
  ) {
    return import("src/pages/Onboarding/lg");
  }

  if (localStorage.getItem(StorageKey.FEAT_TRYBUY)) {
    return import("src/pages/Onboarding/trybuy");
  }

  return import("src/pages/Onboarding/Onboarding");
});

export const SubscribePage = React.lazy(() => {
  throw new Error("unsupported");
});
